export const gold = `

<svg
width="78"
height="86"
viewBox="0 0 78 86"
fill="none"
id="logo"

xmlns="http://www.w3.org/2000/svg"
>
<g filter="url(#filter0_d)">
  <path
    d="M36.5 1.44337C38.047 0.55021 39.953 0.550212 41.5 1.44338L66.8109 16.0566C68.3579 16.9498 69.3109 18.6004 69.3109 20.3868V49.6133C69.3109 51.3996 68.3579 53.0502 66.8109 53.9434L41.5 68.5566C39.953 69.4498 38.047 69.4498 36.5 68.5566L11.1891 53.9434C9.6421 53.0502 8.68911 51.3996 8.68911 49.6132V20.3867C8.68911 18.6004 9.64211 16.9498 11.1891 16.0566L36.5 1.44337Z"
    fill="url(#paint0_linear)"
  />
</g>
<g filter="url(#filter1_i)">
  <path
    d="M36.5 4.06838C38.047 3.17521 39.953 3.17521 41.5 4.06838L64.5376 17.3691C66.0846 18.2623 67.0376 19.9129 67.0376 21.6993V48.3008C67.0376 50.0871 66.0846 51.7377 64.5376 52.6309L41.5 65.9316C39.953 66.8248 38.047 66.8248 36.5 65.9316L13.4624 52.6309C11.9154 51.7377 10.9624 50.0871 10.9624 48.3007V21.6993C10.9624 19.9129 11.9154 18.2623 13.4624 17.3691L36.5 4.06838Z"
    fill="url(#paint1_linear)"
  />
</g>
<rect
  x="12.5571"
  y="54.7137"
  width="60.5876"
  height="26.25"
  transform="rotate(-60 12.5571 54.7137)"
  fill="white"
  fill-opacity="0.16"
/>
<path
  d="M43.4223 20.3338V29.2138C45.7454 30.5275 46.9807 32.9537 46.9807 35.9305C46.9807 40.3607 44.1985 43.4996 38.9791 43.4996C33.7597 43.4996 31.0193 40.2321 31.0193 35.9305C31.0193 32.649 32.4438 30.0971 35.1369 28.898V20.1857C27.5499 21.4099 22.375 26.4355 22.375 35.8019C22.375 46.2919 29.9481 51.625 38.9791 51.625C48.2216 51.625 55.625 46.4205 55.625 35.9305C55.625 27.2042 50.7144 21.8348 43.4223 20.3338Z"
  fill="white"
  fill-opacity="0.33"
  style="mix-blend-mode: luminosity;"
/>
<path
  d="M40.8963 19.0201H39.4746V14.875H38.5258V19.0201H37.1041V30.8043H38.5258V34.9494H39.4746V30.8043H40.8963V19.0201Z"
  fill="white"
  fill-opacity="0.33"
  style="mix-blend-mode: luminosity;"
/>
<defs>
  <filter
    id="filter0_d"
    x="0.689117"
    y="0.773499"
    width="76.6218"
    height="84.453"
    filterUnits="userSpaceOnUse"
    color-interpolation-filters="sRGB"
  >
    <feFlood flood-opacity="0" result="BackgroundImageFix" />
    <feColorMatrix
      in="SourceAlpha"
      type="matrix"
      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    />
    <feOffset dy="8" />
    <feGaussianBlur stdDeviation="4" />
    <feColorMatrix
      type="matrix"
      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
    />
    <feBlend
      mode="normal"
      in2="BackgroundImageFix"
      result="effect1_dropShadow"
    />
    <feBlend
      mode="normal"
      in="SourceGraphic"
      in2="effect1_dropShadow"
      result="shape"
    />
  </filter>
  <filter
    id="filter1_i"
    x="10.9624"
    y="3.3985"
    width="56.0751"
    height="63.203"
    filterUnits="userSpaceOnUse"
    color-interpolation-filters="sRGB"
  >
    <feFlood flood-opacity="0" result="BackgroundImageFix" />
    <feBlend
      mode="normal"
      in="SourceGraphic"
      in2="BackgroundImageFix"
      result="shape"
    />
    <feColorMatrix
      in="SourceAlpha"
      type="matrix"
      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      result="hardAlpha"
    />
    <feOffset />
    <feGaussianBlur stdDeviation="4" />
    <feComposite
      in2="hardAlpha"
      operator="arithmetic"
      k2="-1"
      k3="1"
    />
    <feColorMatrix
      type="matrix"
      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
    />
    <feBlend
      mode="normal"
      in2="shape"
      result="effect1_innerShadow"
    />
  </filter>
  <linearGradient
    id="paint0_linear"
    x1="54.3125"
    y1="8.75"
    x2="25"
    y2="62.5625"
    gradientUnits="userSpaceOnUse"
  >
    <stop stop-color="#D5BF00" />
    <stop offset="0.46875" stop-color="#FFF387" />
    <stop offset="1" stop-color="#D8C200" />
  </linearGradient>
  <linearGradient
    id="paint1_linear"
    x1="16"
    y1="12"
    x2="55.5"
    y2="59.5"
    gradientUnits="userSpaceOnUse"
  >
    <stop stop-color="#FFF495" />
    <stop offset="0.229167" stop-color="#BEAF24" />
    <stop offset="0.734375" stop-color="#BDAE23" />
    <stop offset="1" stop-color="#FFF387" />
  </linearGradient>
</defs>
</svg>
`;

export const silver = `<svg width="78" height="86" viewBox="0 0 78 86" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#f1)">
<path d="M36.5 1.44337C38.047 0.55021 39.953 0.550212 41.5 1.44338L66.8109 16.0566C68.3579 16.9498 69.3109 18.6004 69.3109 20.3868V49.6133C69.3109 51.3996 68.3579 53.0502 66.8109 53.9434L41.5 68.5566C39.953 69.4498 38.047 69.4498 36.5 68.5566L11.1891 53.9434C9.6421 53.0502 8.68911 51.3996 8.68911 49.6132V20.3867C8.68911 18.6004 9.64211 16.9498 11.1891 16.0566L36.5 1.44337Z" fill="url(#p0)"/>
</g>
<g filter="url(#f2)">
<path d="M36.5 4.06838C38.047 3.17521 39.953 3.17521 41.5 4.06838L64.5376 17.3691C66.0846 18.2623 67.0376 19.9129 67.0376 21.6993V48.3008C67.0376 50.0871 66.0846 51.7377 64.5376 52.6309L41.5 65.9316C39.953 66.8248 38.047 66.8248 36.5 65.9316L13.4624 52.6309C11.9154 51.7377 10.9624 50.0871 10.9624 48.3007V21.6993C10.9624 19.9129 11.9154 18.2623 13.4624 17.3691L36.5 4.06838Z" fill="url(#p1)"/>
</g>
<rect x="12.5571" y="54.7137" width="60.5876" height="26.25" transform="rotate(-60 12.5571 54.7137)" fill="white" fill-opacity="0.16"/>
<path d="M43.4223 20.3338V29.2138C45.7454 30.5275 46.9807 32.9537 46.9807 35.9305C46.9807 40.3607 44.1985 43.4996 38.9791 43.4996C33.7597 43.4996 31.0193 40.2321 31.0193 35.9305C31.0193 32.649 32.4438 30.0971 35.1369 28.898V20.1857C27.5499 21.4099 22.375 26.4355 22.375 35.8019C22.375 46.2919 29.9481 51.625 38.9791 51.625C48.2216 51.625 55.625 46.4205 55.625 35.9305C55.625 27.2042 50.7144 21.8348 43.4223 20.3338Z" fill="white" fill-opacity="0.33" style="mix-blend-mode:luminosity"/>
<path d="M40.8962 19.0201H39.4745V14.875H38.5258V19.0201H37.1041V30.8043H38.5258V34.9494H39.4745V30.8043H40.8962V19.0201Z" fill="white" fill-opacity="0.33" style="mix-blend-mode:luminosity"/>
<defs>
<filter id="f1" x="0.689117" y="0.773499" width="76.6218" height="84.453" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
<feOffset dy="8"/>
<feGaussianBlur stdDeviation="4"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
</filter>
<filter id="f2" x="10.9624" y="3.3985" width="56.0751" height="63.203" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
<feBlend mode="normal" in2="shape" result="effect1_innerShadow"/>
</filter>
<linearGradient id="p0" x1="54.3125" y1="8.75" x2="25" y2="62.5625" gradientUnits="userSpaceOnUse">
<stop stop-color="#BABABA"/>
<stop offset="0.5" stop-color="#616161"/>
<stop offset="1" stop-color="#ADADAD"/>
</linearGradient>
<linearGradient id="p1" x1="11" y1="5.25" x2="60.4375" y2="65.625" gradientUnits="userSpaceOnUse">
<stop stop-color="#E5E5E5"/>
<stop offset="0.5" stop-color="#A2A2A2"/>
<stop offset="1" stop-color="#3D3D3D"/>
</linearGradient>
</defs>
</svg>
`;

export const bronze = `<svg width="78" height="86" viewBox="0 0 78 86" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d)">
<path d="M36.5 1.44337C38.047 0.55021 39.953 0.550212 41.5 1.44338L66.8109 16.0566C68.3579 16.9498 69.3109 18.6004 69.3109 20.3868V49.6133C69.3109 51.3996 68.3579 53.0502 66.8109 53.9434L41.5 68.5566C39.953 69.4498 38.047 69.4498 36.5 68.5566L11.1891 53.9434C9.6421 53.0502 8.68911 51.3996 8.68911 49.6132V20.3867C8.68911 18.6004 9.64211 16.9498 11.1891 16.0566L36.5 1.44337Z" fill="url(#p00)"/>
</g>
<g filter="url(#filter1_i)">
<path d="M36.5 4.06838C38.047 3.17521 39.953 3.17521 41.5 4.06838L64.5376 17.3691C66.0846 18.2623 67.0376 19.9129 67.0376 21.6993V48.3008C67.0376 50.0871 66.0846 51.7377 64.5376 52.6309L41.5 65.9316C39.953 66.8248 38.047 66.8248 36.5 65.9316L13.4624 52.6309C11.9154 51.7377 10.9624 50.0871 10.9624 48.3007V21.6993C10.9624 19.9129 11.9154 18.2623 13.4624 17.3691L36.5 4.06838Z" fill="url(#p11)"/>
</g>
<rect x="12.5571" y="54.7137" width="60.5876" height="26.25" transform="rotate(-60 12.5571 54.7137)" fill="white" fill-opacity="0.16"/>
<path d="M43.4223 20.3338V29.2138C45.7454 30.5275 46.9807 32.9537 46.9807 35.9305C46.9807 40.3607 44.1985 43.4996 38.9791 43.4996C33.7597 43.4996 31.0193 40.2321 31.0193 35.9305C31.0193 32.649 32.4438 30.0971 35.1369 28.898V20.1857C27.5499 21.4099 22.375 26.4355 22.375 35.8019C22.375 46.2919 29.9481 51.625 38.9791 51.625C48.2216 51.625 55.625 46.4205 55.625 35.9305C55.625 27.2042 50.7144 21.8348 43.4223 20.3338Z" fill="white" fill-opacity="0.33" style="mix-blend-mode:luminosity"/>
<path d="M40.8962 19.0201H39.4745V14.875H38.5258V19.0201H37.1041V30.8043H38.5258V34.9494H39.4745V30.8043H40.8962V19.0201Z" fill="white" fill-opacity="0.33" style="mix-blend-mode:luminosity"/>
<defs>
<filter id="filter0_d" x="0.689112" y="0.773499" width="76.6218" height="84.453" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
<feOffset dy="8"/>
<feGaussianBlur stdDeviation="4"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
</filter>
<filter id="filter1_i" x="10.9624" y="3.3985" width="56.0751" height="63.203" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
<feBlend mode="normal" in2="shape" result="effect1_innerShadow"/>
</filter>
<linearGradient id="p00" x1="54.3125" y1="8.75" x2="25" y2="62.5625" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD8432"/>
<stop offset="0.5" stop-color="#6D3A0B"/>
<stop offset="1" stop-color="#E38936"/>
</linearGradient>
<linearGradient id="p11" x1="11" y1="5.25" x2="60.4375" y2="65.625" gradientUnits="userSpaceOnUse">
<stop stop-color="#E38936"/>
<stop offset="0.5" stop-color="#6D3A0B"/>
<stop offset="1" stop-color="#DD8432"/>
</linearGradient>
</defs>
</svg>
`;
export const ranking_default = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.5 0.288675C9.8094 0.110043 10.1906 0.110042 10.5 0.288675L18.1603 4.71132C18.4697 4.88996 18.6603 5.22008 18.6603 5.57735V14.4226C18.6603 14.7799 18.4697 15.11 18.1603 15.2887L10.5 19.7113C10.1906 19.89 9.8094 19.89 9.5 19.7113L1.83975 15.2887C1.53034 15.11 1.33975 14.7799 1.33975 14.4226V5.57735C1.33975 5.22009 1.53034 4.88996 1.83975 4.71132L9.5 0.288675Z" fill="#47758D"/>
<path d="M9.5 1.03868C9.8094 0.860042 10.1906 0.860042 10.5 1.03868L17.5107 5.08632C17.8201 5.26496 18.0107 5.59508 18.0107 5.95235V14.0476C18.0107 14.4049 17.8201 14.735 17.5107 14.9137L10.5 18.9613C10.1906 19.14 9.80941 19.14 9.5 18.9613L2.48927 14.9137C2.17987 14.735 1.98927 14.4049 1.98927 14.0476V5.95235C1.98927 5.59508 2.17987 5.26496 2.48927 5.08632L9.5 1.03868Z" fill="#1F4D65"/>
<path d="M11.2636 5.80962V8.34677C11.9273 8.72211 12.2802 9.4153 12.2802 10.2658C12.2802 11.5316 11.4853 12.4284 9.99408 12.4284C8.50282 12.4284 7.71983 11.4949 7.71983 10.2658C7.71983 9.32825 8.12683 8.59913 8.8963 8.25653V5.76729C6.72858 6.11708 5.25004 7.55296 5.25004 10.2291C5.25004 13.2262 7.41379 14.75 9.99408 14.75C12.6348 14.75 14.75 13.263 14.75 10.2658C14.75 7.77258 13.347 6.23847 11.2636 5.80962Z" fill="white" fill-opacity="0.33" style="mix-blend-mode:luminosity"/>
<path d="M10.542 5.43433H10.1358V4.25H9.86478V5.43433H9.45858V8.80123H9.86478V9.98555H10.1358V8.80123H10.542V5.43433Z" fill="white" fill-opacity="0.33" style="mix-blend-mode:luminosity"/>
</svg>
`;

export const ranking_gold = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.5 1.44338C15.047 0.550212 16.953 0.550212 18.5 1.44338L27.3564 6.55662C28.9034 7.44979 29.8564 9.10042 29.8564 10.8868V21.1132C29.8564 22.8996 28.9034 24.5502 27.3564 25.4434L18.5 30.5566C16.953 31.4498 15.047 31.4498 13.5 30.5566L4.64359 25.4434C3.09659 24.5502 2.14359 22.8996 2.14359 21.1132V10.8868C2.14359 9.10042 3.09659 7.44979 4.64359 6.55662L13.5 1.44338Z" fill="url(#paint0_linear_8783_77362)"/>
<g filter="url(#filter0_i_8783_77362)">
<path d="M13.5 2.64339C15.047 1.75022 16.953 1.75022 18.5 2.64339L26.3172 7.15664C27.8642 8.0498 28.8172 9.70043 28.8172 11.4868V20.5133C28.8172 22.2996 27.8642 23.9502 26.3172 24.8434L18.5 29.3566C16.953 30.2498 15.047 30.2498 13.5 29.3566L5.68284 24.8434C4.13583 23.9502 3.18284 22.2996 3.18284 20.5133V11.4868C3.18284 9.70044 4.13583 8.0498 5.68284 7.15664L13.5 2.64339Z" fill="url(#paint1_linear_8783_77362)"/>
</g>
<rect x="3.9118" y="25.012" width="27.6972" height="12" transform="rotate(-60 3.9118 25.012)" fill="white" fill-opacity="0.16"/>

<defs>
<filter id="filter0_i_8783_77362" x="3.18283" y="1.97351" width="25.6344" height="28.053" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
<feBlend mode="normal" in2="shape" result="effect1_innerShadow_8783_77362"/>
</filter>
<linearGradient id="paint0_linear_8783_77362" x1="23" y1="4" x2="9.6" y2="28.6" gradientUnits="userSpaceOnUse">
<stop stop-color="#D5BF00"/>
<stop offset="0.46875" stop-color="#FFF387"/>
<stop offset="1" stop-color="#D8C200"/>
</linearGradient>
<linearGradient id="paint1_linear_8783_77362" x1="5.48573" y1="5.48573" x2="23.5429" y2="27.2" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFF495"/>
<stop offset="0.229167" stop-color="#BEAF24"/>
<stop offset="0.734375" stop-color="#BDAE23"/>
<stop offset="1" stop-color="#FFF387"/>
</linearGradient>
</defs>
</svg>
`;

export const ranking_blue = `<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.9 1.44338C15.447 0.550212 17.353 0.550212 18.9 1.44338L27.7564 6.55662C29.3034 7.44979 30.2564 9.10042 30.2564 10.8868V21.1132C30.2564 22.8996 29.3034 24.5502 27.7564 25.4434L18.9 30.5566C17.353 31.4498 15.447 31.4498 13.9 30.5566L5.04359 25.4434C3.49658 24.5502 2.54359 22.8996 2.54359 21.1132V10.8868C2.54359 9.10042 3.49658 7.44979 5.04359 6.55662L13.9 1.44338Z" fill="url(#paint0_linear_8783_77390)"/>
<g filter="url(#filter0_i_8783_77390)">
<path d="M13.9 2.64339C15.447 1.75022 17.353 1.75022 18.9 2.64339L26.7172 7.15664C28.2642 8.0498 29.2172 9.70043 29.2172 11.4868V20.5133C29.2172 22.2996 28.2642 23.9502 26.7172 24.8434L18.9 29.3566C17.353 30.2498 15.447 30.2498 13.9 29.3566L6.08282 24.8434C4.53581 23.9502 3.58282 22.2996 3.58282 20.5133V11.4868C3.58282 9.70044 4.53581 8.0498 6.08282 7.15664L13.9 2.64339Z" fill="url(#paint1_linear_8783_77390)"/>
</g>
<rect x="4.31181" y="25.012" width="27.6972" height="12" transform="rotate(-60 4.31181 25.012)" fill="white" fill-opacity="0.16"/>
<defs>
<filter id="filter0_i_8783_77390" x="3.58282" y="1.97351" width="25.6343" height="28.053" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
<feBlend mode="normal" in2="shape" result="effect1_innerShadow_8783_77390"/>
</filter>
<linearGradient id="paint0_linear_8783_77390" x1="23.4" y1="4" x2="9.99999" y2="28.6" gradientUnits="userSpaceOnUse">
<stop stop-color="#9CDBFF"/>
<stop offset="0.5" stop-color="#046299"/>
<stop offset="1" stop-color="#9CDBFF"/>
</linearGradient>
<linearGradient id="paint1_linear_8783_77390" x1="3.59999" y1="2.40001" x2="26.2" y2="30" gradientUnits="userSpaceOnUse">
<stop stop-color="#51BFFF"/>
<stop offset="0.5" stop-color="#0694E6"/>
<stop offset="1" stop-color="#03507D"/>
</linearGradient>
</defs>
</svg>
`;

export const ontick_points = `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_8783_77358)">
<path d="M7 0.57735C7.6188 0.220085 8.3812 0.220085 9 0.57735L13.9282 3.42265C14.547 3.77992 14.9282 4.44017 14.9282 5.1547V10.8453C14.9282 11.5598 14.547 12.2201 13.9282 12.5774L9 15.4226C8.3812 15.7799 7.6188 15.7799 7 15.4226L2.0718 12.5774C1.45299 12.2201 1.0718 11.5598 1.0718 10.8453V5.1547C1.0718 4.44017 1.45299 3.77992 2.0718 3.42265L7 0.57735Z" fill="#47758D"/>
<path d="M7 1.17736C7.61881 0.820091 8.3812 0.820091 9.00001 1.17736L13.4086 3.72266C14.0274 4.07992 14.4086 4.74018 14.4086 5.45471V10.5453C14.4086 11.2598 14.0274 11.9201 13.4086 12.2774L9.00001 14.8227C8.3812 15.1799 7.61881 15.1799 7.00001 14.8227L2.59142 12.2774C1.97262 11.9201 1.59142 11.2598 1.59142 10.5453V5.45471C1.59142 4.74018 1.97262 4.07992 2.59142 3.72266L7 1.17736Z" fill="#1F4D65"/>
<path d="M9.01084 4.64772V6.67745C9.54184 6.97772 9.82419 7.53227 9.82419 8.21268C9.82419 9.2253 9.18826 9.94276 7.99526 9.94276C6.80225 9.94276 6.17586 9.19591 6.17586 8.21268C6.17586 7.46263 6.50146 6.87933 7.11704 6.60525V4.61386C5.38286 4.89369 4.20003 6.0424 4.20003 8.18329C4.20003 10.581 5.93103 11.8 7.99526 11.8C10.1078 11.8 11.8 10.6104 11.8 8.21268C11.8 6.21809 10.6776 4.9908 9.01084 4.64772Z" fill="white" fill-opacity="0.33" style="mix-blend-mode:luminosity"/>
<path d="M8.43341 4.34745H8.10845V3.39999H7.8916V4.34745H7.56664V7.04097H7.8916V7.98843H8.10845V7.04097H8.43341V4.34745Z" fill="white" fill-opacity="0.33" style="mix-blend-mode:luminosity"/>
</g>
<defs>
<filter id="filter0_d_8783_77358" x="0" y="0" width="16" height="17" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8783_77358"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8783_77358" result="shape"/>
</filter>
</defs>
</svg>
`;

export const ranking_green = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 0.57735C15.6188 0.220085 16.3812 0.220085 17 0.57735L28.8564 7.42265C29.4752 7.77992 29.8564 8.44017 29.8564 9.1547V22.8453C29.8564 23.5598 29.4752 24.2201 28.8564 24.5774L17 31.4226C16.3812 31.7799 15.6188 31.7799 15 31.4226L3.14359 24.5774C2.52479 24.2201 2.14359 23.5598 2.14359 22.8453V9.1547C2.14359 8.44017 2.52479 7.77992 3.14359 7.42265L15 0.57735Z" fill="url(#paint0_linear_8783_77109)"/>
<g filter="url(#filter0_i_8783_77109)">
<path d="M15 1.77735C15.6188 1.42008 16.3812 1.42008 17 1.77735L27.8172 8.02265C28.436 8.37991 28.8172 9.04017 28.8172 9.7547V22.2453C28.8172 22.9598 28.436 23.6201 27.8172 23.9773L17 30.2226C16.3812 30.5799 15.6188 30.5799 15 30.2226L4.18284 23.9773C3.56403 23.6201 3.18284 22.9598 3.18284 22.2453V9.7547C3.18284 9.04017 3.56403 8.37991 4.18284 8.02265L15 1.77735Z" fill="url(#paint1_linear_8783_77109)"/>
</g>
<rect x="3.91183" y="25.012" width="27.6972" height="12" transform="rotate(-60 3.91183 25.012)" fill="white" fill-opacity="0.16"/>
<defs>
<filter id="filter0_i_8783_77109" x="3.18283" y="1.5094" width="25.6344" height="28.9812" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
<feBlend mode="normal" in2="shape" result="effect1_innerShadow_8783_77109"/>
</filter>
<linearGradient id="paint0_linear_8783_77109" x1="23" y1="4" x2="9.6" y2="28.6" gradientUnits="userSpaceOnUse">
<stop stop-color="#428585"/>
<stop offset="0.5" stop-color="#4C8F8F"/>
<stop offset="1" stop-color="#428585"/>
</linearGradient>
<linearGradient id="paint1_linear_8783_77109" x1="3.20001" y1="2.4" x2="25.8" y2="30" gradientUnits="userSpaceOnUse">
<stop stop-color="#60A3A3"/>
<stop offset="0.5" stop-color="#105353"/>
<stop offset="1" stop-color="#60A3A3"/>
</linearGradient>
</defs>
</svg>
`;
